// import { Dialog, DialogContent, DialogHeader } from '@/components/ui/dialog'
import { useAuth0 } from '@auth0/auth0-react'

const ZeroData = () => {
  const { logout } = useAuth0()

  return (
    // <Dialog open>
    //   <form>
    //     <DialogContent
    //       className='sm:max-w-[425px] bg-white rounded-xl shadow-lg p-6'
    //       hideCloseButton={true}
    //     >
    //       <DialogHeader className='flex justify-center mb-4 w-full'>
    //         <h2 className='text-lg font-semibold text-primary-foreground'>
    //           We're sorry, no sites are currently assigned to your account
    //         </h2>
    //       </DialogHeader>

    //       <div className='flex justify-center'>
    //         <div
    //           className='cursor-pointer px-4 py-2 bg-info-dim text-pprimary-foreground font-semibold rounded-md hover:bg-blue-600 transition-colors duration-200'
    //           onClick={() =>
    //             logout({
    //               logoutParams: { returnTo: `${window.location.origin}/app` },
    //             })
    //           }
    //         >
    //           Sign Out
    //         </div>
    //       </div>
    //     </DialogContent>
    //   </form>
    // </Dialog>

    // createPortal(
    <div className='fixed inset-0 z-[1001] h-full flex items-center justify-center bg-black bg-opacity-50'>
      <div
        className='bg-primary p-6 rounded-lg w-full max-w-[400px] mx-4 flex flex-col gap-4 shadow-lg'
        onClick={e => e.stopPropagation()}
      >
        <div className='flex justify-between items-center text-[18px] font-semibold text-primary-foreground'>
          <p>Error</p>
        </div>
        <div className='flex justify-center items-center text-[14px] font-medium text-primary-foreground'>
          <p className='whitespace-pre-wrap'>
            We're sorry, no sites are currently assigned to your account.
          </p>
        </div>
        <div className='flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-3 pt-2 text-sm sm:text-md'>
          <button
            className={`px-4 py-2.5 rounded-lg bg-accent hover:bg-accent-hover text-accent-foreground w-full sm:w-auto font-medium transition-colors`}
            onClick={() =>
              logout({
                logoutParams: { returnTo: `${window.location.origin}/app` },
              })
            }
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
    //   document.body,
    // )}
  )
}

export default ZeroData
